<template>
	<div class="a " id="asd" >
		<Slider v-model="value" @update="$emit('change-date', value)" :min="1999" :max="new Date().getFullYear()" class="color" />
	</div>
</template>

<script>
import Slider from '@vueform/slider';

export default {
	components: {
		Slider
	},
	data() {
		return {
			value: [1999, new Date().getFullYear()]
		};
	},
	methods:{
		reset(){
			this.value = [1999, new Date().getFullYear()];
		}
	}
};
</script>

<style src="@vueform/slider/themes/default.css">
.a {
	display: block;
	position: relative;
}
</style>
